export { Caption2Strong, caption2StrongClassNames } from './components/presets/Caption2Strong/index';
